// eslint-disable-next-line import/prefer-default-export
export const skyCenterPrimaryPalette = {
    white: '#FFFFFF',
    h5: '#747474',
    h3: '#191919',
    unAnsweredMandatory: '#F0DEBF',
}
